
import {
	GET_CENTROS,
	GET_CENTROS_BY_PAGINATOR,
	CREATE_CENTER,
	UPDATE_CENTER,
	DELETE_CENTER,
	REFACTOR_CENTER,
	GET_ERRORS
} from "../actions/types";

const initialState = {
	centros: [],
	totalPages: 0,
	actionType: "",
	error: ""
};

export default function (state = initialState, action) {
	switch (action.type) {

		case GET_CENTROS:
			return {
				...state,
				actionType: action.type,
				centros: action.payload
			};
		case CREATE_CENTER:
			return {
				...state,
				actionType: action.type
			};

		case GET_CENTROS_BY_PAGINATOR:
			return {
				...state,
				actionType: action.type,
				centros: action.payload.centros,
				totalPages: action.payload.total_pages
			};

		case UPDATE_CENTER:
			return {
				...state,
				actionType: action.type
			};
		case REFACTOR_CENTER:
			return {
				...state,
				actionType: action.type
			};
		case DELETE_CENTER:
			return {
				...state,
				actionType: action.type
			};
		case GET_ERRORS:
			return {
				...state,
				actionType: action.type,
				error: action.payload
			};

		default:
			return state;
	}
}
